import { useState, useEffect } from "react";
import "@/App.css";
import { motion, AnimatePresence } from "framer-motion";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { useLenis } from "@/hooks/useLenis";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { TrustBar } from "@/components/TrustBar";
import { Marquee } from "@/components/Marquee";
import { About } from "@/components/About";
import { Services } from "@/components/Services";
import { Process } from "@/components/Process";
import { Advantages } from "@/components/Advantages";
import { Gallery } from "@/components/Gallery";
import { Testimonials } from "@/components/Testimonials";
import { Faq } from "@/components/Faq";
import { Cta } from "@/components/Cta";
import { BookingSection } from "@/components/BookingSection";
import { Footer } from "@/components/Footer";
import { WhatsAppButton } from "@/components/WhatsAppButton";
import { CallButton } from "@/components/CallButton";
import { LogoMark } from "@/components/Logo";
import LegalNotice from "@/pages/LegalNotice";
import PrivacyPolicy from "@/pages/PrivacyPolicy";

const Intro = () => (
  <motion.div
    initial={{ y: 0 }}
    animate={{ y: "-100%" }}
    transition={{ duration: 0.9, delay: 0.9, ease: [0.76, 0, 0.24, 1] }}
    className="fixed inset-0 z-[100] bg-ink grid place-items-center"
    data-testid="intro-overlay"
  >
    <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }} className="text-center">
      <LogoMark size={56} className="mx-auto" />
      <div className="mt-5 font-heading font-extrabold text-white text-2xl tracking-tight">Ventanas Hondal</div>
      <div className="text-electric text-xs uppercase tracking-[0.3em] mt-2">PVC · Aluminio · Cantabria</div>
    </motion.div>
  </motion.div>
);

const Landing = () => {
  const [showIntro, setShowIntro] = useState(true);
  useEffect(() => {
    const t = setTimeout(() => setShowIntro(false), 2000);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className="App grain">
      <AnimatePresence>{showIntro && <Intro key="intro" />}</AnimatePresence>
      <Navbar />
      <main>
        <Hero />
        <TrustBar />
        <Marquee />
        <About />
        <Services />
        <Process />
        <Advantages />
        <Gallery />
        <Testimonials />
        <Faq />
        <Cta />
        <BookingSection />
      </main>
      <Footer />
      <WhatsAppButton />
      <CallButton />
      <Toaster position="top-center" richColors />
    </div>
  );
};

function App() {
  useLenis();
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/aviso-legal" element={<LegalNotice />} />
        <Route path="/privacidad" element={<PrivacyPolicy />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
